<div class="content-page">
    <div class="content-page__header">
        <app-header-banner
                [localAsset]="true"
                bannerText=""
                bannerImage="trip_testimonials.jpg"
        ></app-header-banner>
    </div>
    <div class="terms-and-conditions" dir="auto">
        <h1 class="title">{{ titlePath | translate }}</h1>
        <ol class="rules">
            @for (rule of (rulesPath | translate | keyvalue); track $index) {
                <li class="rule">
                    <h2 class="rule-title">{{ rule.value['RULE_TITLE'] | translate }}</h2>
                    <ul class="sub-rules">
                        @for (subRule of (rule.value['SUB_RULES']); track $index) {
                            <li class="sub-rule" [innerHTML]="subRule"></li>
                        }
                    </ul>
                </li>
            }
        </ol>
    </div>
    <app-start-planing-mobile></app-start-planing-mobile>
</div>
